<ion-content>

  <ion-refresher (ionRefresh)="doRefresh($event)">
    <ion-refresher-content pullingIcon="arrow-dropdown" pullingText="Pull to refresh" refreshingSpinner="crescent"
      refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>




  <ion-list class="accordion-list" no-lines>


    <ion-list-header *ngFor="let item of categories; let i = index" no-lines no-padding>
      <button ion-item (click)="toggleSection(i)" class="margin" detail-none [ngClass]="{'section-active': item.open, 'section': !item.open}">
        <ion-icon item-right name="add" large *ngIf="!item.open" color="dark" width="24px" height="24px"></ion-icon>
        <ion-icon item-right name="close" large *ngIf="item.open" color="dark" width="24px" height="24px"></ion-icon>
        <p class="ws2"><b>{{ item.CategoryName }}</b></p>
      </button>

      <ion-list *ngIf="item.SubCategory && item.open" no-lines>
        <ion-list-header *ngFor="let child of item.SubCategory; let j = index" no-padding>

          <button ion-item (click)="toggleItem(i, j)" *ngIf="child.children" class="child" detail-none>
            <ion-icon item-left name="add" *ngIf="!child.open"></ion-icon>
            <ion-icon item-left name="close" *ngIf="child.open"></ion-icon>
            {{ child.SubCategoryName }}


          </button>

          <ion-item *ngIf="!child.children" ion-item detail-none class="child-item" text-wrap (click)="clickevent(item,i,j)">
            <h4 text-capitalize>{{ child.SubCategoryName }}</h4>
          </ion-item>

          <ion-list *ngIf="child.children && child.open">
            <ion-item *ngFor="let item of child.children; let k = index" detail-none class="child-item" text-wrap>
              <h2>{{ item.name }}</h2>
              <p text-lowercase>{{ item.information }}</p>
              <button ion-button outline item-end (click)="buyItem(item)">{{ item.price }}</button>
            </ion-item>
          </ion-list>
        </ion-list-header>
      </ion-list>

    </ion-list-header>
  </ion-list>

</ion-content>